module.exports = __webpack_public_path__ + "img/3R.8622aaf1.png";